import { render, staticRenderFns } from "./ModalVerificarPrivado.vue?vue&type=template&id=2c8d92e6"
import script from "./ModalVerificarPrivado.vue?vue&type=script&lang=js"
export * from "./ModalVerificarPrivado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports